module.exports = __webpack_public_path__ + "img/manual_disable_box.9137f32e.png";